<template>
    <app-layout>
        <div class="bax-banner-wrap">
            <div class="bax-banner-title-block" >
                <div class="container">
                    <div class="bax-banner-title d-flex align-items-center">
                        <img src="~@/assets/images/login-img.png" alt="Welcome">
                        <vue-heading :size="6">Rockingham General Hospital</vue-heading>
                        <!-- <strong class="ml-auto">Order Ref: {{ $route.params.id}}</strong> -->
                    </div>
                </div>
            </div>

            <div class="bax-banner-content d-flex align-items-end">
                <div class="container">
                    <h1 class="d-flex align-items-center">Manage Patient</h1>
                </div>
            </div>
        </div>

        <main>
            <div class="bax-section bax-select-patient-wrap">
                <div class="container">
                    <vue-box class="bax-search-bar d-md-flex flex-wrap align-items-md-center">
                        <vue-heading :size="4">Select an Existing Patient</vue-heading>

                        <div class="bax-form-wrapper w-100">
                            <search-patient-form
                                @onSearch="searchPatient"
                            />
                        </div>
                    </vue-box>

                    <div class="bax-search-title" v-if="Object.keys(patientsList).length > 0">
                        <div class="bax-form-wrapper">
                            <form>
                                <div class="bax-section-title d-flex align-items-center">
                                    <div
                                        class="bax-sort-block d-flex
                                        justify-content-between align-items-center ml-auto"
                                    >
                                        <label>sort by</label>
                                        <select @change="sortResult">
                                            <option value="firstName">Firstname</option>
                                            <option value="lastName">Surname</option>
                                            <option value="patientID">Patient ID</option>
                                            <option value="dateOfBirth">DOB</option>
                                            <option value="wardId">Ward</option>
                                            <option value="">Last Order</option>
                                        </select>
                                        <div class="bax-sort-icon">
                                            <a href="javascript:;" title="Sort by">
                                                <i class="icon-arrow-down"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="bax-order-list bax-order-list-manage">
                            <ul>
                                <li
                                    v-for="(patient, index) in patientsList"
                                    :key="index"
                                    class="d-flex flex-wrap align-items-center"
                                >
                                    <div class="bax-order-detail">
                                        <ul class="bax-patient-info d-flex">
                                            <li>
                                                First Name
                                                <strong>{{ patient.firstName ? patient.firstName : '--' }}</strong>
                                            </li>
                                            <li>
                                                Last Name
                                                <strong>{{ patient.lastName ? patient.lastName : '--' }}</strong>
                                            </li>
                                            <li>
                                                Patient ID
                                                <strong>{{ patient.patientID }}</strong>
                                            </li>
                                        </ul>
                                        <ul class="d-flex flex-wrap">
                                            <li>DOB: <strong>{{ patient.dateOfBirth }}</strong></li>
                                            <li>Ward: <strong>N/A</strong></li>
                                            <li>Last Order: <strong>11/03/1990</strong></li>
                                        </ul>
                                    </div>
                                    <div class="bax-order-cta">
                                        <a
                                            href="javascript:;"
                                            class="bax-btn bax-btn-bordered
                                                bax-btn-bordered-dark-gray-1"
                                        >
                                            <i class="icon-edit"></i> Edit
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <!-- <div class="bax-cta-block d-flex justify-content-center">
                            <a
                                href="javascript:;"
                                class="bax-btn bax-btn bax-btn-blue bax-btn-load-more"
                            >Lord More </a>
                        </div> -->
                    </div>

                    <!-- <vue-box class="d-md-flex align-items-md-center">
                        <vue-heading :size="4">Create a New Patient</vue-heading>
                        <div class="ml-auto">
                            <vue-button
                                type="primary"
                                @click="createPatient = true"
                            >Create</vue-button>
                        </div>
                    </vue-box>
                    <div class="bax-cta-block">
                        <vue-button type="link">Back</vue-button>
                    </div> -->
                </div>
            </div>
        </main>
    </app-layout>
</template>

<script>
import arraySort from 'array-sort';
import AppLayout from '@/components/layout/AppLayout.vue';
import SearchPatientForm from '@/components/patient/SearchPatient.vue';

export default {
    name: 'ManagePatient',
    components: {
        AppLayout,
        SearchPatientForm,
    },
    data() {
        return {
            patientsList: [],
        };
    },
    methods: {
        async searchPatient(searchKeyword) {
            try {
                if (searchKeyword.firstName === ''
                    && searchKeyword.lastName === ''
                    && searchKeyword.patientId === ''
                ) {
                    return;
                }

                const searchRequest = await this.$http.post('/api/v1/patient/search?_format=json', {
                    firstName: searchKeyword.firstName,
                    lastName: searchKeyword.lastName,
                    medicalRecordNumber: searchKeyword.patientId,
                }, {
                    headers: {
                        'X-CSRF-Token': sessionStorage.getItem('X-CSRF-Token'),
                    },
                });

                this.patientsList = searchRequest.data;
            } catch (err) {
                if (err.response.status === 404) {
                    this.patientsList = [];
                }
            }
        },
        sortResult(e) {
            if (e.target.value !== '') {
                const r = this.patientsList;

                if (e.target.value === 'dateOfBirth') {
                    /* eslint-disable */
                    this.patients = r.sort((a, b) => new Date(a.dateOfBirth) - new Date(b.dateOfBirth));
                } else {
                    this.patients = arraySort(r, e.target.value);
                }
            }
        },
    },
};
</script>
